// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wa_a bhe_b bhe_wb"};